import { realApi } from './api';

// Todo /yo/* cuelga de la sesión: el backend resuelve qué jugador es. Si el
// usuario no tiene jugador vinculado (ADMIN/COMITE) responde 403 SIN_JUGADOR.
const conTemporada = (ruta, temporada) =>
  realApi.get(temporada ? `${ruta}?temporada=${encodeURIComponent(temporada)}` : ruta).then((r) => r.datos);

export const getResumen = (temporada) => conTemporada('/yo/resumen', temporada);
export const getPartidos = (temporada) => conTemporada('/yo/partidos', temporada);

// Catálogo de estados con etiqueta y colores (tabla estados_partido_visible).
export const getEstadosPartido = () => realApi.get('/estados-partido').then((r) => r.datos);

// Solo alias y correo. null o vacío los borra; devuelve los valores guardados
// (el correo vuelve normalizado en minúsculas).
export const actualizarPerfil = (datos) => realApi.patch('/yo/perfil', datos).then((r) => r.datos);

// Solicitud de revisión de un partido propio: el backend la guarda y envía un
// correo al comité. Si el correo falla responde 502 CORREO_NO_ENVIADO (la
// solicitud queda guardada); más de 5 por hora responde 429.
export const solicitarRevision = (partidoId, texto) =>
  realApi.post(`/yo/partidos/${partidoId}/revision`, { texto }).then((r) => r.datos);
